import { type InsuranceCorporateIdentity } from "../types";

export function AlteOldenburgerLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M414.126 319.439V409H296.5C304 403.5 313.5 395.5 318.282 386.068H390.863V296.197L414.126 319.439ZM260.279 165.73L171.258 254.361L139 254.051L244.15 149.305L260.279 165.73ZM311.148 114.907L298.431 127.612L282.301 111.188L320.143 74L361.396 124.204L346.818 138.459L311.148 114.907ZM223.058 74L456 306.734L439.561 323.158L231.122 114.907L195.762 138.459L181.184 124.204L223.058 74ZM240 267C200.44 267 178 295.446 178 338.231C178 381.248 200.672 409 240 409C279.56 409 302 381.016 302 338.231C302 295.446 279.328 267 240 267ZM240 391.886C214.784 391.886 201.828 373.847 201.828 338.231C201.828 302.616 214.552 284.577 240 284.577C265.216 284.577 278.172 302.616 278.172 338.231C278.172 373.847 265.216 391.886 240 391.886ZM156.432 409H181L133.486 273H106.368L57 408.54H80.4093L90.6075 378.394H146.002L156.432 409ZM140.207 361.135H96.1701L118.884 295.782H119.116L140.207 361.135Z"
        fill="white"
      />
    </svg>
  );
}

export const AlteOldenburger: InsuranceCorporateIdentity = {
  id: "alte-oldenburger",
  name: "Alte Oldenburger",
  logo: AlteOldenburgerLogo,
  backgroundColor: "#17356C",
  textColor: "#FFFFFF",
  wildcard: "alte oldenburger",
  type: "private",
};
